// extracted by mini-css-extract-plugin
export var attachment = "_q8-a";
export var emailContainer = "_q8-4";
export var emailContentPaddedContainer = "_q8-b";
export var emailHeader = "_q8-6";
export var emailIframe = "_q8-3";
export var emailInfoIcon = "_q8-9";
export var emailShortenedSummary = "_q8-e";
export var infoDropdown = "_q8-0";
export var infoRowBoundedContent = "_q8-d";
export var internal = "_q8-5";
export var merchant = "_q8-8";
export var messageInputContainer = "_q8-h";
export var normal = "_q8-7";
export var replyCard = "_q8-f";
export var subtleButton = "_q8-1";
export var subtleButtonIconContainer = "_q8-2";
export var toggleViewRepliesButton = "_q8-c";
export var wrappingText = "_q8-g";